import { Dayjs } from 'dayjs';
import { array, mixed, number, object, ObjectSchema, string } from 'yup';

import { ProcessStatusDto, ResourceTypeDto, TaskStatusDto } from '@/api/generated';
import { DATE_TO_TEST } from '@/utils/form/dateTo.validation.ts';
import {
  selectSearchOptionOptionalValidation,
  selectSearchOptionRequiredValidation,
} from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { TasksListSearchFormModel } from '@/views/tasks/list/model/TasksListSearchForm.model.ts';

export const useTasksFormValidation = (): ObjectSchema<TasksListSearchFormModel> => {
  const { t } = useTranslationWithPrefix('validation');

  return object().shape({
    assignedUserId: selectSearchOptionOptionalValidation<string>(string()).nullable(),
    contextResourceId: string().optional(),
    contextResourceTypes: array()
      .of(selectSearchOptionRequiredValidation<ResourceTypeDto>(string(), t))
      .required(t('general.required')),
    creationDateFrom: mixed<Dayjs>().optional().nullable(),
    creationDateTo: DATE_TO_TEST(t, 'creationDateFrom').optional().nullable(),
    creatorUserId: selectSearchOptionOptionalValidation<string>(string()).nullable(),
    customerId: selectSearchOptionOptionalValidation<number>(number()),
    dueDateFrom: mixed<Dayjs>().optional().nullable(),
    dueDateTo: DATE_TO_TEST(t, 'dueDateFrom').optional().nullable(),
    fullTextSearchInput: string().optional(),
    status: selectSearchOptionOptionalValidation<ProcessStatusDto>(string()),
    taskStatuses: array()
      .of(selectSearchOptionRequiredValidation<TaskStatusDto>(string(), t))
      .required(t('general.required')),
    watchersUserIds: array().of(selectSearchOptionRequiredValidation<string>(string(), t)).ensure(),
  });
};
